import { render, staticRenderFns } from "./toShowOrderNoDetail.vue?vue&type=template&id=514ab9fa&scoped=true"
import script from "./toShowOrderNoDetail.vue?vue&type=script&lang=js"
export * from "./toShowOrderNoDetail.vue?vue&type=script&lang=js"
import style0 from "./toShowOrderNoDetail.vue?vue&type=style&index=0&id=514ab9fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514ab9fa",
  null
  
)

export default component.exports